import React from "react";
import styled, { css } from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";

const palette = {
  teal:  { bg: "#e8f5f6", text: COLORS.BTN_GREEN, bd: "#b5dde1" },
  navy:  { bg: "#e8ecf5", text: COLORS.COLOR_DARK, bd: "#c5d0e0" },
  gold:  { bg: "#fff7e6", text: "#c98d18", bd: "#f0deb8" },
  grey:  { bg: "#f0f4f8", text: "#5c6b7f", bd: COLORS.BORDER_GREY },
};

const sizes = {
  sm: css`font-size: 10px; padding: 2px 7px;`,
  md: css`font-size: 11px; padding: 3px 9px;`,
};

const Pill = styled.span`
  display: inline-block;
  background: ${({ $color }) => (palette[$color] || palette.grey).bg};
  color: ${({ $color }) => (palette[$color] || palette.grey).text};
  border: 1px solid ${({ $color }) => (palette[$color] || palette.grey).bd};
  border-radius: 4px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-weight: 600;
  ${({ $size }) => sizes[$size] || sizes.md}
`;

const Badge = ({ children, color = "grey", size = "md" }) => (
  <Pill $color={color} $size={size}>{children}</Pill>
);

export default Badge;
